import { render } from "./IndexingWice.vue?vue&type=template&id=8f7bac70&scoped=true"
import script from "./IndexingWice.vue?vue&type=script&lang=js"
export * from "./IndexingWice.vue?vue&type=script&lang=js"

import "./IndexingWice.vue?vue&type=style&index=0&id=8f7bac70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f7bac70"]])

export default __exports__